import { FC, Key, ReactNode, useMemo, CSSProperties } from "react";
// 组件
import { ProSpace, ProImage, ProTooltip, } from "../antd";
import ButtonGroup from "../ButtonGroup";
// 方法
import classNames from "classnames";
// 常量
import { CardItemProps } from "./interface";
import { CommonlyTypeEnum } from "../SuperTable/interface";

const buttonGroupStyle: CSSProperties = { width: 'auto', };
/** 卡片 */
const CardItem: FC<CardItemProps> = props => {
  const {
    index, record, imageKey, style, titleKey = 'title', subTitleKey = 'subTitle', codeKey,
    iconOperation, beforeOperation, afterOperation, onClickOperation,
  } = props;
  const containerClasses = useMemo(() => {
    return classNames('card-item-body-container', {
      'no-image': !imageKey,
    });
  }, [imageKey]);
  const handleMenuClick = (key: Key,) => {
    onClickOperation && onClickOperation(key, record, index);
  };
  /** 标题栏后面的图标按钮 */
  const newIconOperation = useMemo(() => {
    if (!iconOperation) return null;
    if (typeof iconOperation === 'string') {
      const btn = CommonlyTypeEnum[iconOperation];
      const classes = classNames('operation-icon', 'text-danger');
      return (
        <ProSpace>
          <ProTooltip title={btn.label}>
            <div className={classes} onClick={() => handleMenuClick(btn.key)}>{btn.icon}</div>
          </ProTooltip>
        </ProSpace>
      );
    }
    if (Array.isArray(iconOperation) && iconOperation.length) {
      const btns = iconOperation.map(v => {
        if (typeof v === 'string') return CommonlyTypeEnum[v];
        return v;
      });
      return (
        <ProSpace>
          {
            btns.map(item => {
              const classes = classNames('operation-icon', 'text-danger');
              return (
                <ProTooltip title={item.label}>
                  <div className={classes} onClick={() => handleMenuClick(item.key)}>{item.icon}</div>
                </ProTooltip>
              );
            })
          }
        </ProSpace>
      );
    }
    if (typeof iconOperation === 'function') {
      const btns = iconOperation(record, index);
      return btns;
    }
  }, [iconOperation, record]);
  /** 底部左侧按钮 */
  const newBeforeOperation = useMemo(() => {
    if (!beforeOperation) return null;
    if (typeof beforeOperation === 'string') {
      const btns = [CommonlyTypeEnum[beforeOperation]];
      return (
        <ButtonGroup
          btnLists={btns}
          style={buttonGroupStyle}
          onClick={key => handleMenuClick(key)}
        />
      );
    }
    if (Array.isArray(beforeOperation) && beforeOperation.length) {
      const btns = beforeOperation.map(v => {
        if (typeof v === 'string') return CommonlyTypeEnum[v];
        return v;
      });
      return (
        <ButtonGroup
          btnLists={btns}
          style={buttonGroupStyle}
          onClick={key => handleMenuClick(key)}
        />
      );
    }
    if (typeof beforeOperation === 'function') {
      const btns = beforeOperation(record, index);
      return btns;
    }
  }, [beforeOperation, record]);
  /** 底部右侧按钮 */
  const newAfterOperation = useMemo(() => {
    if (!afterOperation) return null;
    if (typeof afterOperation === 'string') {
      const btns = [CommonlyTypeEnum[afterOperation]];
      return (
        <ButtonGroup
          btnLists={btns}
          style={buttonGroupStyle}
          onClick={key => handleMenuClick(key)}
        />
      );
    }
    if (Array.isArray(afterOperation) && afterOperation.length) {
      const btns = afterOperation.map(v => {
        if (typeof v === 'string') return CommonlyTypeEnum[v];
        return v;
      });
      return (
        <ButtonGroup
          btnLists={btns}
          style={buttonGroupStyle}
          onClick={key => handleMenuClick(key)}
        />
      );
    }
    if (typeof afterOperation === 'function') {
      const btns = afterOperation(record, index);
      return btns;
    }
  }, [afterOperation, record]);
  return (
    <div className="yb-card-item-wrapper" style={style}>
      <div className="yb-card-item">
        <div className="card-item-body">
          {
            imageKey && (
              <div className="card-item-body-image">
                <div className="card-item-body-image-container">
                  <ProImage src={record[imageKey]} width={60} />
                </div>
              </div>
            )
          }
          <div className={containerClasses}>
            <div className="body-container-title">
              <div className="body-container-title-text yb-line-ellipsis-1">
                <ProTooltip title={record[titleKey]} placement='topLeft'>
                  <span>{record[titleKey]}</span>
                </ProTooltip>
                {
                  codeKey && record[codeKey] && (
                    <span className="text-sub">{record[codeKey]}</span>
                  )
                }
              </div>
              <div className="body-container-title-operation">{newIconOperation as ReactNode}</div>
            </div>
            <div className="body-container-sub-title yb-line-ellipsis-2">{record[subTitleKey]}</div>
          </div>
        </div>
        <div className="card-item-footer">
          <div className="card-item-footer-operation card-item-footer-left">{newBeforeOperation as ReactNode}</div>
          <div className="card-item-footer-operation card-item-footer-right">{newAfterOperation as ReactNode}</div>
        </div>
      </div>
    </div>
  );
};

export default CardItem;